"use client";

import { createFileRoute, redirect } from "@tanstack/react-router";

/** Alter Sammelpfad „Vorlagen": dauerhafte Umleitung auf die Kämmerei-Vorlage. */
export const Route = createFileRoute("/_cockpit/cockpit/hundert-tage/vorlagen/")({
  beforeLoad: () => {
    throw redirect({ to: "/cockpit/hundert-tage/vorlagen/kaemmerei" });
  },
});
